export default __webpack_public_path__ + "media/images/client-logos/hm-land-registry-57c9deba3ce68054d46c2e1b48c22b33.png";